import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UiStateService {
  readonly searchOpen = signal<boolean>(false);
  readonly filtersOpen = signal<boolean>(false);
  readonly expandedRecordId = signal<string>('');
  readonly statusSelected = signal<'pending' | 'outgoing' | 'completed'>('pending');
  readonly schedulerTabSelected = signal<'all' | 'load' | 'shunting' | 'transloading' | 'receiving' | 'transferred'>('all');
  readonly refreshing = signal<boolean>(false);

  setSearchOpen(isOpen: boolean): void {
    this.searchOpen.set(isOpen);
  }

  setFiltersOpen(isOpen: boolean): void {
    this.filtersOpen.set(isOpen);
  }

  setExpandedRecord(id: string): void {
    this.expandedRecordId.set(id);
  }

  setStatusSelected(value: 'pending' | 'outgoing' | 'completed'): void {
    this.statusSelected.set(value);
  }

  setSchedulerTabSelected(value: 'all' | 'load' | 'shunting' | 'transloading' | 'receiving' | 'transferred'): void {
    this.schedulerTabSelected.set(value);
  }

  setRefreshing(isRefreshing: boolean): void {
    this.refreshing.set(isRefreshing);
  }
}
